import webservice from '../webservice/webservice';
import { setDebugEnabled, debugLog } from './devLogger';

/**
 * Load the server DEBUG flag and turn the in-browser devLogger on/off
 * accordingly. The API's DEBUG env var is the source of truth (see the public
 * `debug` GraphQL query). Best-effort: any failure leaves logging OFF so the
 * console stays clean when the flag can't be read.
 */
export default async () => {
  try {
    const enabled = await webservice.system.debug();
    setDebugEnabled(enabled === true);
    // This first line only prints when logging ended up enabled.
    debugLog(
      'config',
      `devLogger ${enabled === true ? 'ENABLED' : 'disabled'} (server DEBUG=${enabled})`,
    );
  } catch {
    setDebugEnabled(false);
  }
};
